export default __webpack_public_path__ + "static/ic_logo_white-f7213edfcaa4dbeaf7aaa5a8c1b392fe.svg";